import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon } from '@material-ui/icons'

import { AppointmentDialog } from 'src/modules/supply_chain/components/AppointmentDialog'
import { DateTimeField, RelatedLinkedField, ValueField } from 'src/components/Table'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const AppointmentDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)

  return (
    <>
      {updateOpen && (
        <AppointmentDialog
          open={updateOpen}
          appointment={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Appointment', onClick: () => setUpdateOpen(true) }],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          {
            id: 'asn',
            label: 'Advanced Shipping Notice',
            renderer: RelatedLinkedField(ValueField, 'name'),
          },
          { id: 'truckload', label: 'Truckload', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'appointmentType', label: 'Appointment Type', renderer: ValueField },
          { id: 'start', label: 'Start Time', renderer: DateTimeField },
          { id: 'end', label: 'End Time', renderer: DateTimeField },
          { id: 'broker', label: 'Broker', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'dock', label: 'Dock Door', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'driver', label: 'Driver', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'internalNotes', label: 'Internal Notes', renderer: ValueField },
          { id: 'arrivedOn', label: 'Arrived On', renderer: DateTimeField },
          { id: 'dockedOn', label: 'Docked On', renderer: DateTimeField },
          { id: 'departedOn', label: 'Departed On', renderer: DateTimeField },
        ]}
      />
    </>
  )
}
